// extracted by mini-css-extract-plugin
export default {"textbox":"styles__textbox__cnrhw"};